// extracted by css-extract-rspack-plugin
export default {"cls1":"useNoClaimsToast-cls1_Rz9","cls2":"useNoClaimsToast-cls2_PkO useNoClaimsToast-cls1_Rz9"};